import { TextField } from "../../../../utils/form";

const Password = ({ form: { control }, label = "Contraseña" }) => {
  return (
    <>
      <TextField control={control} name="password" type="password" label={label} variant="outlined" required helperText="Mínimo 10 caracteres, con mayúscula, minúscula, número y carácter especial. No puede contener tu email, dni o número de matrícula" style={{ width: "100%" }} />
      <TextField control={control} name="passwordConfirmation" type="password" label="Repita la contraseña" variant="outlined" required style={{ width: "100%" }} />
    </>
  );
};

export default Password;
